// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3597":"ec2c2a80","3725":"8fbe8df4","3970":"49e2cde1","5347":"0b637252","9626":"5ec5741b"}[chunkId] + ".chunk.css";
};